module.exports = __webpack_public_path__ + "static/img/product-swipe44.6e5d55f7.png";